import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { initial, compact } from 'lodash';

const AddRedirect = () => {
  const location = useLocation();

  return (
    <Redirect to={`/${initial(compact(location.pathname.split('/'))).join('/')}/add`} />
  );
};

export default AddRedirect;
